import React from "react";

const Experience = () => {
  return (
    <div>
      <h3>Soft Skills</h3>
      <h4 style={{ textDecoration: "underline" }}>Leadership & Organization</h4>
      <ul>
        <li>
          I regularly lead a team of 4 people - I outline the work that needs to
          be done, create a timeline for the day, and then assign work to the
          team member I believe is best suited to complete that task.
        </li>
      </ul>
      <h4 style={{ textDecoration: "underline" }}>Trust & Reliability</h4>
      <ul>
        <li>
          I am trusted to handle thousands of dollars in cash every time I close
          the store.
        </li>
        <li>
          I am often the only member of management scheduled to close the store.
          Because of this, I must have an excellent attendance record, since any
          absence on my part will cause problems. I have an excellent record.
        </li>
      </ul>
      <h4 style={{ textDecoration: "underline" }}>Conflict Resolution</h4>
      <ul>
        <li>
          Managing customer complaints is a daily occurrence which has given me
          the ability to stay professional with clients, even under pressure.
        </li>
      </ul>
    </div>
  );
};

export default Experience;
